export default __webpack_public_path__ + "fcea1a2435073df5e71542f546a5e841.svg";